import { render, staticRenderFns } from "./Tencent.vue?vue&type=template&id=996221b4&scoped=true"
import script from "./Tencent.vue?vue&type=script&lang=js"
export * from "./Tencent.vue?vue&type=script&lang=js"
import style0 from "./Tencent.vue?vue&type=style&index=0&id=996221b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996221b4",
  null
  
)

export default component.exports